<template>
    <!--e-commerce-->
    <div v-if="product.ShopActive && this.isSoldOut == false">
        <!--stock info-->
        <div class="stockcontainer" v-if="product.StoreSaleProduct != null || (partnumber != null)" v-show="(isRetailDirectToConsumer == false || setShowDealerSelector)">
            <div class="heading-and-link clearfix" v-if="isRetailDirectToConsumer == false && isStore == false">
                <div class="heading">
                    <div class="heading-and-tooltip">
                        <h4>
                            {{getInterfaceText('shop_howtogetit')}}
                        </h4>
                        <div class="a360tooltip-container" v-show="partnumber != null && partnumber.stock != null && partnumber.stock.Code == 1 && displayInstockLabelAsInfoIconPopout == true">
                            <button class="trigger" v-on:click="toggleA360Tooltip" aria-controls="stock-tooltip" aria-expanded="false">
                                <i class="glyphicon glyphicon glyphicon-info-sign" aria-hidden="true"></i>
                                <span class="sr-only">{{getInterfaceText('shop_howtogetit')}}</span>
                            </button>
                            <div id="stock-tooltip" class="a360tooltip" role="tooltip">{{ stockDescription }}</div>
                        </div>

                        <!--<span v-show="partnumber != null && partnumber.stock != null && partnumber.stock.Code == 1 && displayInstockLabelAsInfoIconPopout == true" class="filter-tooltip" data-toggle="tooltip" data-placement="top" :data-original-title="stockDescription"><span class="glyphicon glyphicon-info-sign"></span></span>-->
                    </div>
                </div>
                <div class="link">
                    <a v-if="countryId == 1" href="#" v-on:click="trackPickItUpInStore" data-toggle="modal" data-target="#modalWhyPickupInStore">Why pick up in store?</a>
                    <a v-else-if="product.WhyPickItUpInStorePageUrl != null && product.WhyPickItUpInStorePageUrl.length > 0" v-on:click="trackPickItUpInStore" data-fancybox data-type="iframe" href="javascript:void(0);" :data-src="product.WhyPickItUpInStorePageUrl" class="pull-right">{{getInterfaceText('page_whypickupinstore_link_label')}}</a>
                </div>
            </div>

            <div class="storesaleproduct" v-if="product.StoreSaleProduct != null">
                <p class="availablesizes" v-if="product.StoreSaleProduct.AvailableSizes != null">
                    <strong>{{getInterfaceText('store_availablesizes')}}</strong>: {{product.StoreSaleProduct.AvailableSizes}}<br />
                    <span class="instoreonly">{{getInterfaceText('instoresalelabel')}}</span>
                </p>
            </div>

            <!-- WhyPickupInStore modal -->
            <div id="modalWhyPickupInStore" v-if="countryId == 1" class="modal fade" role="dialog" aria-modal="true" aria-label="Why pick up in store?" @keydown="handleKeydown" ref="modal">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
                            <h2 class="modal-title" style="color:#000;text-transform: none;">Why pick up in store?</h2>
                        </div>
                        <div class="modal-body text-left" style="padding: 25px;">

                            <p style="padding-bottom:20px;">
                                <img v-if="product.Product.BrandId == 3" src="https://static.giant-bicycles.com/Images/Shared/Shop/image_whypickitupinstore_momentum.jpg" class="img-responsive lazy-loading" alt="" width="848" height="343" />
                                <img v-else src="https://static.giant-bicycles.com/Images/Shared/Shop/image_whypickupinstore5.jpg" class="img-responsive lazy-loading" alt="" width="848" height="343" />
                            </p>

                            <p>
                                {{getInterfaceText('whypickitupinstore_modal_paragraph_one')}}
                                {{getInterfaceText('whypickitupinstore_modal_paragraph_two')}}
                                <strong>
                                    {{getInterfaceText('whypickitupinstore_modal_paragraph_three')}}
                                </strong>
                            </p>
                            <p>
                                {{getInterfaceText('whypickitupinstore_modal_paragraph_four')}}
                            </p>
                          

                        </div>
                    </div>
                </div>
            </div>
            <div v-if="partnumber != null">
                <div class="stock-info-wrapper" v-if="isRetailDirectToConsumer == false && !(isStore && product.StoreSaleProduct != null)">
                    <p class="stockinfo" :class="partnumber.stock.CssClass">{{partnumber.stock.Label}}<br /></p>
                    <p class="stockdescription" v-if="partnumber.stock.Code != 1 && partnumber.stock.Code != 2 && partnumber.stock.Description != null">{{partnumber.stock.Description}}</p>
                    <p v-if="partnumber.stock.Code == 3">
                        {{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup-preorder1')}}&nbsp;<strong>{{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup-preorder2')}}&nbsp;{{partnumber.stock.DateExpectedToFormat}}</strong>
                        <span v-show="product.Product.ProductType == 1">
                            &nbsp;{{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup-preorder3')}}
                            {{label_shop_at_any_retailer}}
                            {{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup-preorder4')}}
                            <strong>{{getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickupabout-preorder5')}} <span v-if="partnumber.stock.DateExpectedToWeeks <= 1">1 {{getInterfaceText('shop_week')}}</span><span v-show="partnumber.stock.DateExpectedToWeeks > 1">{{partnumber.stock.DateExpectedToWeeks}}-{{partnumber.stock.DateExpectedToWeeks + 1}} {{getInterfaceText('shop_weeks')}}</span></strong>
                        </span>
                    </p>
                    <p class="stockdescription" v-else-if="partnumber.stock.Code == 0 && partnumber.notifyMe == false">
                        {{getInterfaceText('shop_productoutofstockcontactlocalstore')}}
                    </p>
                    <p class="stockdescription" v-else-if="partnumber.stock.Code == 2 && isStore == false">
                        <span v-html="label_shop_inStoreNowAndAvailableForPickup.replace('{{ dealerSearchCity }}',dealerSearchCity)"></span>
                    </p>
                    <p class="stockdescription" v-else-if="partnumber.stock.Code == 2 && isStore == true">
                        <span v-show="partnumber.stock.Type == 'LimboStock'">{{getInterfaceText('limbo_available_from_sub')}}</span>
                        <span v-show="partnumber.stock.Type == 'BufferStock'">{{getInterfaceText('buffer_available_from_sub')}}</span>
                    </p>
                    <p class="stockdescription" v-else-if="partnumber.stock.Code == 1 && isStore">
                        <span v-html="getInterfaceText('shop_shipsfromwarehouseandwillbeavailableforpickup')" /> <span v-html="getInterfaceText('shop_inabout7businessdays.')" />
                    </p>
                    <div class="notify-me-wrapper" v-else-if="partnumber.stock.Code == 0 && partnumber.notifyMe == true && isStore == false">
                        <h4>{{getInterfaceText('shop_notifywhenavailable')}}</h4>
                        <NotifyMe :partnumberCode="partnumber.code"></NotifyMe>
                    </div>
                    <p class="stockdescription" v-if="displayInstockLabelAsInfoIconPopout == false && partnumber.stock != null && partnumber.stock.Code == 1">
                        {{stockDescription}}
                    </p>
                </div>

                <div class="dealers-wrapper" v-if="isStore == false && partnumber.stock.ContainsLocalstock">
                    <a href="javascript:void(0)" class="show-dealer-selector" :class="{'active': setShowDealerSelector, '': !setShowDealerSelector}" v-show="partnumber != null && partnumber.stock.Code != 2 && isRetailDirectToConsumer == false" @click="updateShowDealerSelector(!setShowDealerSelector)">
                        <span v-show="setShowDealerSelector == false">{{getInterfaceText('shop_rd2c_showretailersthathaveinstore')}}</span>
                        <span v-show="setShowDealerSelector == true">{{getInterfaceText('shop_rd2c_hideretailersthathaveinstore')}}</span>
                    </a>
                    <div v-if="setShowDealerSelector">
                        <template v-if="isSelectedDealerInfoVisible(item)">
                            <!--YES a dealer has been selected-->
                            <div class="selected-dealer-wrapper">
                                <DealerSelect :dealer="selectedDealer"
                                              :selectedDealer="selectedDealer"
                                              :isInStoreNowTextVisible="true"
                                              :isAvailableInTextVisible="true"
                                              v-on:select-dealer-and-add-to-cart="selectDealerAndAddToCart"
                                              v-on:remove-selected-dealer="removeSelectedDealer"></DealerSelect>
                            </div>

                        </template>
                        <template v-else>
                            <!--title-->
                            <p v-show="isDealerSearchFieldEnabled" class="select-a-dealer">
                                <strong>
                                    <span v-show="isRetailDirectToConsumer == false">{{getInterfaceText('shop_findwherebikeisinstore')}}</span>
                                    <span v-show="isRetailDirectToConsumer == true">{{getInterfaceText('shop_rd2c_findwherebikeisinstore', product.Product.Name + ' (' + partnumber.description + ', ' + partnumber.color + ')')}}</span>
                                </strong>
                            </p>

                            <!--dealer search-->
                            <div class="form-group" rel="tooltip" data-placement="left" v-show="isDealerSearchFieldEnabled">
                                <div class="wrapper-floating-label-and-buttongroup clearfix">
                                    <div class="wrapper-floating-label" :class="{ 'movelabel' : dealerSearchCity != null && dealerSearchCity != '' }" style="width:100%;">
                                        <label for="inputFindLocalStock">{{getInterfaceText('shop_searchonzipcodeorcity')}}</label>
                                        <input type="text" v-model="dealerSearchCity" ref="zipcodeCityInput" v-on:keyup.enter="getDealersByLocation()" id="inputFindLocalStock" style="border-top-left-radius: 4px; border-bottom-left-radius: 4px;max-width:inherit;" />
                                    </div>
                                    <div class="input-group input-group-floating-label-style">
                                        <span class="input-group-btn">
                                            <button type="button" class="btn btn-storefinder" id="btnFindLocalStock" v-on:click="getDealersByLocation()" style="border-top-right-radius: 4px !important; border-bottom-right-radius: 4px !important; margin-left:-45px;" :title="getInterfaceText('shop_searchonzipcodeorcity')"><i class="glyphicon glyphicon-map-marker" aria-hidden="true"></i></button>
                                        </span>
                                    </div>
                                </div>
                                <div class="alert alert-danger" v-show="exceptionMessageDealers.length > 0">{{exceptionMessageDealers}}</div>
                            </div>

                            <!--local stock only checkbox-->
                            <label for="filterOnlyLocalStock" class="filter-on-local-stock" v-if="isLocalStockFilterCheckboxVisible() && partnumber.stock.IsRetailDirectToConsumer == false && producttypeid == 1" style="margin-bottom:10px;">
                                <input type="checkbox" v-model="isLocalStockOnlyMode" v-on:change="toggleLocalStockOnlyMode()" id="filterOnlyLocalStock" />
                                {{getInterfaceText('shop_onlyshowdealershaveinstore')}}
                            </label>

                            <!--dealers to select-->
                            <div class="dealers" v-if="isDealerListVisible">
                                <div v-if="loadingDealers" class="loading">{{getInterfaceText('loading')}}</div>
                                <div v-if="isDealerListVisible && !loadingDealers">
                                    <template v-for="dealer in activeDealers" :key="dealer.Code">
                                        <DealerSelect :dealer="dealer"
                                                      :selectedDealer="selectedDealer"
                                                      :isInStoreNowTextVisible="dealer.Type == 'local'"
                                                      :isAvailableInTextVisible="isAvailableInTextVisible"
                                                      :partnumber="partnumber"
                                                      :product="product"
                                                      v-on:select-dealer-and-add-to-cart="selectDealerAndAddToCart"
                                                      v-on:remove-selected-dealer="removeSelectedDealer"></DealerSelect>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>

                <div v-if="partnumber.stock.Code == 2 && partnumber.notifyMe == true && isStore == false" class="notifyme-wrapper">
                    <a href="javascript:void(0);" v-on:click="showNotifyMe = showNotifyMe ? false : true">{{getInterfaceText('shop_notifywhenavailableatwarehouse')}}</a>
                    <NotifyMe v-show="showNotifyMe" :partnumberCode="partnumber.code" style="margin-top:20px;"></NotifyMe>
                </div>

            </div>
        </div>

        <!-- add to cart button -->
        <p v-show="showLabelRequiredPartnumber == true" class="alert alert-danger">
            {{getInterfaceText('shop_please_select_a_size')}}
        </p>

        <p class="add-to-cart">
            <button class="btn btn-addtocart" v-show="isAddToCartButtonVisible()" v-on:click="addToCart()">{{getInterfaceText('add_to_cart')}}</button>
            <!--<button class="btn btn-contactus" v-show="isContactButtonVisible()" data-toggle="modal" data-target="#contactModal2" style="padding:12px;"><span class="text">{{getInterfaceText('shop_contactdealer_store')}}</span></button>-->
            <button class="btn btn-contactus" v-show="isContactButtonVisible()" v-on:click="sendToContactPage()" style="padding:12px;"><span class="text">{{getInterfaceText('shop_contactdealer_store')}}</span></button>
        </p>
    </div>
    <div class="modal fade" id="contactModal2" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header text-left">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" style="font-weight:bold;" id="myModalLabel">{{getInterfaceText("contact")}}</h4>
                </div>
                <div class="modal-body text-left">
                    <p class="errormessage" v-if="errorContact.length > 0">{{errorContact}}</p>
                    <p style="margin-bottom:20px;font-style: italic;">{{getInterfaceText("store_ihaveaquestionaboutthe")}} {{product.Product.Name}}</p>
                    <div class="successMessage" v-show="formHasBeenSent == true"><p style="color: #1a8f09;font-weight:bold;">{{getInterfaceText("form_sent_successfully")}}</p></div>
                    <div class="clearfix" v-show="formHasBeenSent == false">
                        <div class="form-group">
                            <div class="wrapper-floating-label movelabel">
                                <label>{{getInterfaceText("form_firstname")}} <span class="asterisk">*</span></label>
                                <input id="FirstName" name="FirstName" type="text" style="border-radius: 4px;" v-model="contactFirstName" required :class="errorContact.length > 0 && (contactFirstName == null || contactFirstName == '') ? 'input-validation-error' : ''" />
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="wrapper-floating-label movelabel">
                                <label>{{getInterfaceText("form_lastname")}} <span class="asterisk">*</span></label>
                                <input id="LastName" name="LastName" type="text" style="border-radius: 4px;" v-model="contactLastName" required :class="errorContact.length > 0 && (contactLastName == null || contactLastName == '') ? 'input-validation-error' : ''" />
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="wrapper-floating-label movelabel">
                                <label>{{getInterfaceText("contact-form_email")}} <span class="asterisk">*</span></label>
                                <input id="Email" name="Email" type="email" style="border-radius: 4px;" v-model="contactEmail" required :class="errorContact.length > 0 && (contactEmail == null || contactEmail == '') ? 'input-validation-error' : ''" />
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="wrapper-floating-label movelabel">
                                <label>{{getInterfaceText("contact-form_phone")}}</label>
                                <input id="Phone" name="Phone" type="text" style="border-radius: 4px;" v-model="contactPhone" />
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="wrapper-floating-label movelabel">
                                <label>{{getInterfaceText("contact-form_size")}}</label>
                                <input id="Size" name="Size" type="text" style="border-radius: 4px;" v-model="contactSize" />
                            </div>
                        </div>
                        <div class="form-group" style="margin-bottom: 15px;">
                            <label style="font-weight:normal;">{{getInterfaceText("contact-form_question")}} <span class="asterisk">*</span></label>
                            <textarea class="form-control" id="Question" name="Question" style="border-radius: 4px;" v-model="contactQuestion" required :class="errorContact.length > 0 && (contactQuestion == null || contactQuestion == '') ? 'input-validation-error' : ''"></textarea>
                        </div>
                        <p class="text-right">
                            <button class="btn btn-default" data-dismiss="modal" style="margin-right:5px;">{{getInterfaceText("cancel", "Cancel")}}</button>
                            <button class="btn btn-primary" ng-disabled="isSending" v-on:click="sendContactForm()">{{getInterfaceText("send")}}</button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import generalMixin from '../mixins/general.js';
    import cartMixin from '../mixins/cart-mixin.js';
    import vueStore from '../store/store.js';
    import NotifyMe from '../components/NotifyMe.vue';
    import DealerSelect from '../components/DealerSelect.vue';
    export default {
        name: 'SelectedPartnumber',
        mixins: [cartMixin, generalMixin],
        props: {
            setShowDealerSelector: Boolean
        },
        components: {
            NotifyMe,
            DealerSelect
        },
        data: function () {
            return {
                isStore: window.store.length > 0,
                displayInstockLabelAsInfoIconPopout: true,
                countryId: window.countryId,
                label_shop_at_any_retailer: window.label_shop_at_any_retailer,
                label_shop_inStoreNowAndAvailableForPickup: window.label_shop_inStoreNowAndAvailableForPickup,
                isAvailableInTextVisible: true,
                isDealerSearchFieldEnabled: false,
                isLocalStockOnlyMode: true,
                isWillingToTakeARoadTrip: false,
                isDealerListVisible: true,
                exceptionMessageDealers: '',
                activeDealers: [],
                dealerSearchCity: '',
                showNotifyMe: false,
                errorContact: '',
                isSending: false,
                formHasBeenSent: false,
                grecaptcha: window.grecaptcha,
                showLabelRequiredPartnumber: false,
                sellLocalStockStoreSites: false
            }
        },
        methods: {
            isAddToCartButtonVisible() {
                if (this.isStore && this.product?.StoreSaleProduct != null) {
                    return false;
                }

                var enable = false;
                // can we show the ADD TO CART button?
                //if (this.product && this.product.Product && item && item.stock.Code > 0 && this.hasWarehouseDealers()) {
                //    // scenario 1: warehouse stock dealers AND stock > 0
                //    enable = true;
                //}
                if (this.product && this.product.Product && this.partnumber && (this.partnumber.stock.Code == 1 || this.partnumber.stock.Code == 3)) {
                    // scenario 1: warehouse or pre-order stock available
                    enable = true;
                }
                else if (this.product && this.product.Product && this.partnumber && this.partnumber.stock.Code > 0 && this.hasLocalStockDealers() && this.hasSelectedDealer) {
                    // scenario 2: local stock dealers AND selected dealer AND stock > 0
                    enable = true;
                }
                else if (this.product && this.product.Product && this.partnumber && this.partnumber.stock.IsRetailDirectToConsumer) {
                    // scenario 3: RD2C
                    enable = true;
                } else if (this.partnumber == null && this.isSoldOut == false) {
                    //scenario 4: no partnumber selected. Show disabled button
                    enable = true;
                } else if (this.isStore) {
                    //scenario 5: store scenarios
                    if (this.partnumber && this.partnumber.stock.Code == 2 && this.sellLocalStockStoreSites) {
                        enable = true;
                    }
                }

                return enable;
            },
            isContactButtonVisible() {
                var enable = false;
                if (this.isStore == true && this.isAddToCartButtonVisible() == false && this.partnumber && this.partnumber.stock.Code == 2) {
                    enable = true;
                } else if (this.isStore == true && this.product.StoreSaleProduct != null) {
                    enable = true;
                } else if (this.isStore == true && this.partnumber && this.partnumber.stock.Code == 0) {
                    enable = true;
                }

                return enable;
            },
            sendToContactPage() {
                window.location = '/' + window.culture + '/contact?productid=' + (this.product != null && this.product.Product != null ? this.product.Product.Id : '') + '&producttype=' + (this.product != null && this.product.Product != null ? this.product.Product.ProductType : '') + '&size=' + (this.product.StoreSaleProduct != null && this.product.StoreSaleProduct.AvailableSizes != null ? this.product.StoreSaleProduct.AvailableSizes.replace('&', '-') : '') + '&partnumber=' + (this.partnumber != null ? this.partnumber.code : this.product != null && this.product.Partnumbers != null && this.product.Partnumbers.length > 0 ? this.product.Partnumbers[0].code : '');
            },
            trackPickItUpInStore() {
                // SK add ga4 tracking
                var clickText = this.getInterfaceText('page_whypickupinstore_link_label');
                window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'why_pickup_in_store', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': clickText });
            },
            isSelectedDealerInfoVisible(item) {
                return (this.selectedDealer && this.selectedDealer?.Code && item && item.stock.Code > 0 && this.inProgressAddingProductToCart == false);
            },
            selectDealerAndAddToCart(dealer) {

                // SK add ga4 tracking
                window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'select_retailer', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_click_text': dealer.Name, 'ga4_retailer_name': dealer.Name });

                // set  dealer in vue-store
                vueStore.commit('setDealer', dealer);

                // add to cart
                this.addCartItem(this.partnumber.code, this.product.Product.Id, this.product.Product.ProductType, this.product.Product, null, function () { document.getElementById("cart-summary-container2").click(); });
            },
            removeSelectedDealer() {
                vueStore.commit('setDealer', null);
            },
            toggleLocalStockOnlyMode() {
                this.setActiveDealers(!this.isLocalStockOnlyMode)
            },
            resetDealerSearch() {
                this.isWillingToTakeARoadTrip = false;
                this.isDealerSearchFieldEnabled = false;
                this.isDealerListVisible = false;
                this.isLocalStockOnlyMode = true;
            },
            isLocalStockFilterCheckboxVisible() {
                var hasLocalAndWarehouseStock = this.dealers.findIndex(x => x.Type == 'local') > -1 && this.dealers.findIndex(x => x.Type == 'warehouse') > -1 && this.isDealerListVisible;
                return hasLocalAndWarehouseStock;
            },
            getDealersByGeocode(lat, lng) {
                console.log("getDealersByGeocode");

                var that = this;
                this.exceptionMessageDealers = '';

                // define url
                var url = '/' + window.culture + '/shop/dealers2' + (window.store != undefined && window.store.length > 0 ? '?store=' + window.store : '');

                // create object
                var myDealerRequest = {
                    partnumberCode: this.partnumber.code,
                    productId: this.product.Product.Id,
                    productType: this.product.Product.ProductType,
                    latitude: lat != undefined ? lat : window.defaultLatitude,
                    longitude: lng != undefined ? lng : window.defaultLongitude
                }

                // call api
                axios({
                    method: "post",
                    url: url,
                    data: myDealerRequest,
                })
                    .then(function (response) {
                        //handle success
                        if (response.data) {
                            // put data in store
                            vueStore.commit('setDealers', response.data)

                            // Set the active dealers with logic based on the data
                            that.setActiveDealers()
                        }

                    })
                    .catch(function (response) {
                        //handle error
                        that.exceptionMessageDealers = response;
                        console.error(response)
                    });
            },
            getDealersByLocation() {

                this.loadingDealers = true;
                this.exceptionMessageDealers = '';
                var callback = function (that, lat, lng) {

                    if (lat != undefined) {
                        that.getDealersByGeocode(lat, lng);
                        that.isClientSearchFieldEnabled = false;
                    } else {
                        // do we need something here?
                        that.exceptionMessageDealers = 'Could not find this place'
                    }
                };

                this.setClientLocation(this.dealerSearchCity, callback, this);
            },
            setActiveDealers(showAllDealers = false) {
                console.log("setActiveDealers() - showAllDealers : " + showAllDealers);

                if (showAllDealers || this.isLocalStockOnlyMode == false) {
                    // Set active dealers to all available dealers.
                    // Sort by distance, smallest distance first.
                    this.activeDealers = this.warehouseAndlocalstockDealersWithinRadius
                        .slice()
                        .sort(function (a, b) {
                            return a.Distance - b.Distance;
                        });
                } else {

                    if (this.hasLocalStockDealers()) {
                        // scenario: local dealers
                        this.isDealerListVisible = true;
                        //show dealer search
                        this.isDealerSearchFieldEnabled = true;

                        console.log("show all local dealers inside and outside radius");
                        // scenario: local dealers outside radius only
                        this.activeDealers = this.localstockDealers;
                    }

                    // in roadtrip mode always show list
                    if (this.isWillingToTakeARoadTrip == true) {
                        this.isDealerListVisible = true;
                    }

                }

                // loading done
                this.loadingDealers = false;
            },
            getDealers() {
                // remove selected dealer
                this.removeSelectedDealer();
                // reset dealer search settings
                this.resetDealerSearch();
                //reset notify me form
                this.isNotifyMeVisible = false;
                //reset required label
                this.showLabelRequiredPartnumber = false;

                if (this.partnumber != null && this.partnumber.stock.Code != 0 && this.partnumber.stock.ContainsLocalstock == true && (window.store == undefined || window.store.length == 0)) {
                    this.getDealersByGeocode(this.clientLocation.lat, this.clientLocation.lng)
                }

                if (this.partnumber != null && this.partnumber.stock.Code == 2 && this.partnumber.stock.ContainsLocalstock == true && this.partnumber.stock.IsRetailDirectToConsumer == false) {
                    this.updateShowDealerSelector(true);
                    //this.private_setShowDealerSelector = true;
                } else {
                    this.updateShowDealerSelector(false);
                    //this.private_setShowDealerSelector = false;
                }
            },
            setClientLocation(item, callback, that, skipCountry) {
                var thisParent = this
                window.getLatLng(item + (skipCountry == true || (window.containsRelatedCountryIds != undefined && window.containsRelatedCountryIds == true) ? '' : ' ' + window.country), function (lat, lng) {
                    if (lat != null) {
                        var clientlocation = { city: item, lat: lat, lng: lng }
                        vueStore.commit('setClientLocation', clientlocation)
                        document.cookie = 'clientLocation=' + JSON.stringify(clientlocation) + '; path=/' + window.culture;

                        if (callback) {
                            callback(that, lat, lng)
                        }
                    } else if (skipCountry == true) {
                        //stop trying....
                        if (callback) {
                            callback(that, lat, lng)
                        }
                    } else {
                        //try to find without country suffix
                        thisParent.setClientLocation(item, callback, that, true)
                    }
                })
            },
            getClientLocation() {
                var clientLocation = window.readCookie('clientLocation')
                if (clientLocation != null) {
                    try {
                        vueStore.commit('setClientLocation', JSON.parse(clientLocation))
                    } catch (e) {
                        console.log(e);
                    }
                }
            },
            getBrowserLocation(callback) {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                        var latlng = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude);
                        var geocoder = new window.google.maps.Geocoder();
                        geocoder.geocode({ latLng: latlng }, function (results, status) {
                            var city = '';
                            if (status == window.google.maps.GeocoderStatus.OK) {
                                if (results[1]) {
                                    var arrAddress = results;
                                    console.log(results);
                                    for (var i = 0; i < arrAddress.length; i++) {
                                        if (arrAddress[i].types[0] == "locality") {
                                            console.log("dealercity: " + arrAddress[i].address_components[0].long_name);
                                            city = arrAddress[i].address_components[0].long_name;
                                        }
                                    }

                                    if (city.length == 0) {
                                        //try to find by administrative_area_level_4
                                        for (var j = 0; j < arrAddress.length; j++) {
                                            if (arrAddress[j].types[0] == "administrative_area_level_4") {
                                                console.log("dealercity: " + arrAddress[j].address_components[0].long_name);
                                                city = arrAddress[j].address_components[0].long_name;
                                            }
                                        }
                                    }
                                    if (city.length == 0) {
                                        //try to find by postal_town
                                        for (var k = 0; k < arrAddress.length; k++) {
                                            if (arrAddress[i].types[0] == "postal_town") {
                                                console.log("dealercity: " + arrAddress[k].address_components[0].long_name);
                                                city = arrAddress[k].address_components[0].long_name;
                                            }
                                        }
                                    }
                                } else {
                                    city = window.lblNoLocationFound;
                                }
                            } else {
                                //Raygun.send("Google Maps Geocoder exception. Status: " + status);
                                city = "Geocoder failed due to: " + status;
                            }

                            var clientlocation = { city: city, lat: position.coords.latitude, lng: position.coords.longitude }
                            vueStore.commit('setClientLocation', clientlocation)
                            document.cookie = 'clientLocation=' + JSON.stringify(clientlocation) + '; path=/' + window.culture;
                            if (callback) {
                                callback();
                            }
                        });
                    }, function () {
                        if (callback) {
                            callback();
                        }
                    }, { timeout: 5000 });//5sec
                }
            },
            hasLocalStockDealers() {
                return (this.dealers?.filter(x => x.Type == 'local').length > 0);
            },
            addToCart() {
                if (this.partnumber != null) {
                    this.addCartItem(this.partnumber.code, this.product.Product.Id, this.product.Product.ProductType, this.product.Product, null, function () { document.getElementById("cart-summary-container2").click(); });
                } else {
                    this.showLabelRequiredPartnumber = true;
                }
            },
            //sendToContact() {
            //    window.location = '/' + this.culture + '/contact';
            //},
            sendContactForm() {
                if (this.isSending == false) {
                    this.errorContact = '';
                    this.isSending = true;
                    this.formHasBeenSent = false;

                    if (
                        this.contactFirstName?.length > 0 &&
                        this.contactLastName?.length > 0 &&
                        this.contactEmail?.length > 0 &&
                        this.contactQuestion?.length > 0
                    ) {
                        const that = this;

                        try {

                            // handle recaptcha
                            this.grecaptcha.ready(() => {
                                this.grecaptcha.execute(window.GoogleRecaptchaSiteKey, { action: 'social' })
                                    .then(token => {
                                        const url = `/${this.$root.culture}/contact/sendjson`;

                                        console.log("token:", token);

                                        const formData = {
                                            FirstName: that.contactFirstName,
                                            LastName: that.contactLastName,
                                            email: that.contactEmail,
                                            phone: that.contactPhone,
                                            size: that.contactSize,
                                            question: that.contactQuestion,
                                            ProductId: that.product.Product.Id,
                                            ProductType: that.product.Product.ProductType,
                                            isGlobalCatalogue: that.product.Product.IsGlobalCatalogue,
                                            token: token
                                        };

                                        console.log("Form data:", JSON.stringify(formData, null, 2));

                                        axios({
                                            method: "post",
                                            url: url,
                                            data: formData,
                                        })
                                            .then(res => {
                                                if (res.data === 'True') {
                                                    that.formHasBeenSent = true;
                                                } else {
                                                    that.errorContact = res.data;
                                                }
                                                that.isSending = false;
                                            })
                                            .catch((error) => {
                                                console.error("Axios error:", error);
                                                that.errorContact = 'An error occurred while sending the form';
                                                that.isSending = false;
                                            });
                                    })
                                    .catch(function (ex) {
                                        // any error -> set button style back to normal
                                        that.errorContact = 'Invalid token: ' + ex;
                                        that.isSending = false;
                                    });
                            });

                        } catch (err) {
                            this.errorContact = 'An unexpected error occurred: ' + err.message;
                            this.isSending = false;
                        }

                    } else {
                        this.errorContact = this.getInterfaceText('makesureallrequiredfieldsareentered');
                        this.isSending = false;
                    }
                }
            },
            updateShowDealerSelector(value) {
                this.$emit('update:setShowDealerSelector', value);
            },
            handleKeydown(event) {
                const focusableElements = this.getFocusableElements();
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];

                if (event.key === 'Tab') {
                    if (event.shiftKey) {
                        // Shift + Tab
                        if (document.activeElement === firstElement) {
                            event.preventDefault();
                            lastElement.focus();
                        }
                    } else {
                        // Tab
                        if (document.activeElement === lastElement) {
                            event.preventDefault();
                            firstElement.focus();
                        }
                    }
                }
            },
            getFocusableElements() {
                return this.$refs.modal.querySelectorAll(
                    'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
                );
            },
            toggleA360Tooltip(event) {
                const btn = event.currentTarget; // de geklikte knop
                const tooltipId = btn.getAttribute("aria-controls");
                const tooltip = document.getElementById(tooltipId);

                const isOpen = btn.getAttribute("aria-expanded") === "true";

                if (isOpen) {
                    // Sluiten
                    btn.setAttribute("aria-expanded", "false");
                    tooltip.style.display = "none";
                } else {
                    // button
                    btn.setAttribute("aria-expanded", "true");
                    tooltip.style.display = "block";
                }
            }
        },
        computed: {
            partnumber() {
                if (vueStore.state == undefined) {
                    return null;
                }
                return vueStore.state.partnumber
            },
            isRetailDirectToConsumer() {
                return this.partnumber != null && this.partnumber.stock != null && (this.partnumber.stock.IsRetailDirectToConsumer || this.product.DirectshipmentAvailableGear == true && this.partnumber.stock.Code == 1);
            },
            product() {
                return vueStore.state.product
            },
            stockDescription() {
                return this.partnumber != null && this.partnumber.stock != null ? this.partnumber.stock.Description : '';
            },
            selectedDealer() {
                return vueStore.state.dealer
            },
            inProgressAddingProductToCart() {
                return vueStore.state.addingProductToCart
            },
            dealers() {
                return vueStore.state.dealers
            },
            clientLocation() {
                return vueStore.state.clientLocation
            },
            localstockDealers() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.Type == 'local');
                } else {
                    return [];
                }
            },
            warehouseAndlocalstockDealersWithinRadius() {
                if (this.dealers && this.dealers.length) {
                    return this.dealers.filter(x => x.IsDealerWithinRadius);
                } else {
                    return [];
                }
            },
            isSellable() {
                return this.product.Partnumbers?.filter(x => x.stock != null && x.stock.Code != 0).length > 0
            },
            isSoldOut() {
                return this.isSellable == false && this.product.Partnumbers?.filter(x => x.notifyMe == true).length == 0
            }
        },
        watch: {
            partnumber() {
                this.getDealers();
            }
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
            this.displayInstockLabelAsInfoIconPopout = document.getElementById('vue-parameters').dataset.displayinstocklabelasinfoiconpopout == 'true';
            this.partnumberDefault = window.getParameterByName('partnumber'); //document.getElementById('vue-product-selector-v2').dataset.partnumberdefault;
            this.sellLocalStockStoreSites = document.getElementById('vue-product-selector-v2').dataset.selllocalstockstoresites == 'true';

            /*Zet default location*/
            this.getClientLocation();
            if (this.clientLocation != null && this.clientLocation.city != null) {
                this.dealerSearchCity = this.clientLocation.city
            } else {
                var that = this;
                this.getBrowserLocation(function () {
                    if (that.clientLocation != null && that.clientLocation.city != null) {
                        that.dealerSearchCity = that.clientLocation.city
                    } else {
                        that.dealerSearchCity = window.defaultCityEnglish;
                    }
                });
            }

            /*get default dealers*/
            if ((this.partnumberDefault != null && this.partnumberDefault.length > 0)
                || (this.product.Partnumbers != null && this.product.Partnumbers.length == 1)
                || (this.product.Partnumbers.map(p => p.color).length == this.product.Colors.length) //Indien een product 1 kleur heeft met one size dan gelijk de dealers ophalen
            ) {
                this.getDealers();
            }
        },
        //beforeMount() {
        //    this.getClientLocation();
        //    if (this.clientLocation != null && this.clientLocation.city != null) {
        //        this.dealerSearchCity = this.clientLocation.city
        //    } else {
        //        var that = this;
        //        this.getBrowserLocation(function () {
        //            if (that.clientLocation != null && that.clientLocation.city != null) {
        //                that.dealerSearchCity = that.clientLocation.city
        //            } else {
        //                that.dealerSearchCity = window.defaultCityEnglish;
        //            }
        //        });
        //    }
        //},
        //mounted() {
        //this.$nextTick(() => {
        //    const focusableElements = this.getFocusableElements();
        //    if (focusableElements.length) {
        //        focusableElements[0].focus(); // Focus op het eerste element bij openen
        //    }
        //});
        //}
    }
</script>
